import { Route } from '@angular/router';


export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('./content'),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth'),
  },
];
